// extracted by mini-css-extract-plugin
module.exports = {"item":"List_item__1E91_"};